var Vendd = (function(Vendd) {
    'use strict';

    Vendd.DatabindingTypes = (function (DatabindingTypes) {

        DatabindingTypes.DataMember = "dataMember";
        DatabindingTypes.DataShow = "dataShow";

        return DatabindingTypes;

    })(Vendd.DatabindingTypes || {});

    Vendd.Databinding = (function(Databinding) {

        var bindings = [];

        Databinding.CreateControlDatabindings = function(wrapper, data) {

            var controlDatabindings = Vendd.DatabindingHelpers.ResolveControlDatabinding(wrapper, data);

            Databinding.BindControls(controlDatabindings);
        };

        Databinding.DestroyControlDatabindings = function (wrapper, data) {

            var controlDatabindings = Vendd.DatabindingHelpers.ResolveControlDatabinding(wrapper, data);

            Databinding.UnbindControls(controlDatabindings);
        };

        Databinding.BindControls = function(controlDataProperty) {
            if (controlDataProperty && Array.isArray(controlDataProperty)) {
                for (var i = 0; i < controlDataProperty.length; i++) {
                    var cdp = controlDataProperty[i];

                    var control = cdp.Control;
                    var data = cdp.Data;
                    var propertyName = cdp.PropertyName;
                    var type = cdp.Type;

                    if (!control && !data && !propertyName) continue;

                    Databinding.BindControl(control, data, propertyName, type);
                }
            }
        };

        Databinding.UnbindControls = function(controlDataProperty) {
            if (controlDataProperty && Array.isArray(controlDataProperty)) {
                for (var i = 0; i < controlDataProperty.length; i++) {
                    var cdp = controlDataProperty[i];

                    var control = cdp.Control;
                    var data = cdp.Data;
                    var propertyName = cdp.PropertyName;
                    var type = cdp.Type;

                    if (!control && !data && !propertyName) continue;

                    Databinding.UnbindControl(control, data, propertyName, type);
                }
            }
        };

        Databinding.BindControl = function (control, data, propertyName, type) {
            if (control && typeof control === 'object') {

                var pos = Vendd.DatabindingHelpers.FindBinding(control, data, propertyName, type);
                var binding = (pos === -1) ? Vendd.DatabindingHelpers.CreateBinding(control, data, propertyName, type, bindings) : bindings[pos];

                binding.Event = Vendd.DatabindingEvents.ControlChanged;

                if (data instanceof Vendd.Observable) {
                    data.AddListenerToPropertyChanged(propertyName, Vendd.DatabindingEvents.PropertyChanged);
                }

                var eventCode = Vendd.DatabindingHelpers.GetEventCode(control);
                var value = data[propertyName];

                // we must use jQuery to bind the events because jQuery hooks on change event globally per control and disables our handlers unless we use his API
                switch (binding.Type)
                {
                    case Vendd.DatabindingTypes.DataMember:
                        $(control).unbind(eventCode, binding.Event);
                        Vendd.Control.SetValue(control, value);
                        $(control).bind(eventCode, binding.Event);
                        break;
                    case Vendd.DatabindingTypes.DataShow:
                        Vendd.Control.SetVisibility(control, value);
                        break;
                }
            };
        };

        Databinding.UnbindControl = function (control, data, propertyName, type) {
            if (control && typeof control === 'object') {
                var pos = Vendd.DatabindingHelpers.FindBinding(control, data, propertyName, type);
                if (pos === -1)
                    return;

                var event = bindings[pos].Event;
                bindings.splice(pos, 1);

                var indexes = Vendd.DatabindingHelpers.FindControlBindings(control);
                if (indexes.length === 0) {

                    var eventCode = Vendd.DatabindingHelpers.GetEventCode(control);

                    if (control.addEventListener) {
                        control.removeEventListener(eventCode, event);
                    } else {
                        control.detachEvent(eventCode, event);
                    };

                };
            };
        };

        Databinding.GetCurrentBindings = function getCurrentBindings() {
            return bindings;
        };

        return Databinding;

    })(Vendd.Databinding || {});

    Vendd.DatabindingHelpers = (function (DatabindingHelpers) {

        DatabindingHelpers.GetEventCode = function (control) {
            if (typeof ($(control).data("event")) == "string") {

                return $(control).data("event");
            }
            var controlType = Vendd.Control.GetType(control);

            switch (controlType) {
                default:
                    return 'change';
            }
        };

        DatabindingHelpers.FindBinding = function findBinding(control, data, propertyName, type) {

            var bindings = Vendd.Databinding.GetCurrentBindings();

            if (typeof control === 'object') {
                for (var i = 0; i < bindings.length; i++) {
                    if (bindings[i].Control === control &&
                        bindings[i].Data === data &&
                        bindings[i].Type === type &&
                        bindings[i].PropertyName === propertyName)
                        return i;
                };
            };

            return -1;
        };

        DatabindingHelpers.FindControlBindings = function findControlBindings(control) {
            var res = [];

            var bindings = Vendd.Databinding.GetCurrentBindings();

            if (typeof control === 'object') {
                for (var i = 0; i < bindings.length; i++) {
                    if (bindings[i].Control === control)
                        res.push(i);
                };
            };

            return res;
        };

        DatabindingHelpers.FindPropertyBindings = function findPropertyBindings(data, propertyName, forceUpdate) {

            if (forceUpdate === null || typeof(forceUpdate) != "boolean")
                forceUpdate = false;

            var bindings = Vendd.Databinding.GetCurrentBindings();
            var res = [];

            if (typeof data === 'object' && typeof propertyName === 'string') {
                for (var i = 0; i < bindings.length; i++) {
                    if (bindings[i].Data === data && bindings[i].PropertyName === propertyName)
                        res.push(i);
                };
            };

            return res;
        };

        DatabindingHelpers.CreateBinding = function createBinding(control, data, propertyName, type, bindings) {
            var binding = {
                Control: control,
                Data: data,
                PropertyName: propertyName,
                Type: type,
                Event: null
            };
            bindings.push(binding);

            return binding;
        };

        DatabindingHelpers.ResolveControlDatabinding = function(wrapper, data) {

            var controlDatabindings = [];

            if (!data) 
                return controlDatabindings;

            $('*[data-member]', wrapper).each(function (i, dataMemberControl) {

                var $dataMemberControl = $(dataMemberControl);

                var dataMemberPath = $dataMemberControl.data('member');
                var propertyName = dataMemberPath.split('.').pop();

                var innerData = data.GetChildObservableByPath(dataMemberPath);

                var controlDatabinding = {
                    Control: dataMemberControl,
                    Data: innerData,
                    PropertyName: propertyName,
                    Type: Vendd.DatabindingTypes.DataMember
                };

                controlDatabindings.push(controlDatabinding);
            });

            $('*[data-show]', wrapper).each(function (i, dataShowControl) {

                var $dataShowControl = $(dataShowControl);

                var dataShowPath = $dataShowControl.data('show');
                var propertyName = dataShowPath.split('.').pop();

                var innerData = data.GetChildObservableByPath(dataShowPath);

                var controlDatabinding = {
                    Control: dataShowControl,
                    Data: innerData,
                    PropertyName: propertyName,
                    Type: Vendd.DatabindingTypes.DataShow
                };

                controlDatabindings.push(controlDatabinding);
            });

            return controlDatabindings;
        };

        return DatabindingHelpers;

    })(Vendd.DatabindingHelpers || {});

    Vendd.DatabindingEvents = (function (DatabindingEvents) {

        DatabindingEvents.ControlChanged = function controlChanged(event) {
            var target = event.target || event.srcElement;
            var indexes = Vendd.DatabindingHelpers.FindControlBindings(target);
            if (indexes.length === 0)
                return;

            var bindings = Vendd.Databinding.GetCurrentBindings();

            for (var i = 0; i < indexes.length; i++) {
                var binding = bindings[indexes[i]];
                var control = binding.Control;
                var data = binding.Data;
                var propertyName = binding.PropertyName;

                try {
                    data[propertyName] = Vendd.Control.GetValue(control, typeof data[propertyName]);
                } catch (ex) {
                    Vendd.ControlHelpers.HandleError(target, data[propertyName], ex);
                }
             
            };
        };

        DatabindingEvents.PropertyChanged = function propertyChanged(data, propertyName, value) {

            var bindings = Vendd.Databinding.GetCurrentBindings();

            var indexes = Vendd.DatabindingHelpers.FindPropertyBindings(data, propertyName);
            if (indexes.length === 0)
                return;

            for (var i = 0; i < indexes.length; i++) {
                var binding = bindings[indexes[i]];
                var control = binding.Control;

                switch (binding.Type)
                {
                    case Vendd.DatabindingTypes.DataMember:
                        Vendd.Control.SetValue(control, value);
                        break;
                    case Vendd.DatabindingTypes.DataShow:
                        Vendd.Control.SetVisibility(control, value);
                        break;
                }
            };
        };

        return DatabindingEvents;

    })(Vendd.DatabindingEvents || {});

    return Vendd;

})(Vendd || {});